import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { CartProvider } from "./context/CartProvider";
import { ColorModeContext, useMode } from "./context/ThemeProvider";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Admin/Dashboard";
import Profile from "./pages/User/Profile";
import Offer from "./pages/User/Offer";
import Confirmation from "./pages/User/Confirmation";
import Sales from "./pages/Admin/Sales";
import User from "./pages/Admin/User";
import DoorPrize from "./pages/Admin/DoorPrize";
import Contract from "./pages/User/Contract";
import DealSuccess from "./pages/User/DealSuccess";
import GrandPrize from "./pages/Admin/GrandPrize";
import SetWin from "./pages/Admin/SetWin";
import GuestPrizeI from "./pages/Admin/GuestPrizeI";
import GuestPrizeII from "./pages/Admin/GuestPrizeII";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <AuthProvider>
      <CartProvider>
        <ColorModeContext.Provider value={colorMode}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="" element={<Layout />}>
                {/* Halaman User */}
                <Route path="/profile" element={<Profile />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="/contract" element={<Contract />} />
                <Route path="/deal-success" element={<DealSuccess />} />
                {/* Halaman Admin */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/user" element={<User />} />

                <Route path="/setWin" element={<SetWin />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/doorprize" element={<DoorPrize />} />
              <Route path="/grandprize" element={<GrandPrize />} />
              <Route path="/doorprizesesi1" element={<GuestPrizeI />} />
              <Route path="/doorprizesesi2" element={<GuestPrizeII />} />
            </Routes>
          </ThemeProvider>
        </ColorModeContext.Provider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
